import {cmsApi} from './api';

/**
 * User Management Service
 * Handles user CRUD operations through CMS backend
 */

export const userService = {
  /**
   * Get all users
   */
  async getUsers(params = {}) {
    return cmsApi.getUsers(params);
  },

  /**
   * Get user by ID
   */
  async getUser(id) {
    return cmsApi.getUser(id);
  },

  /**
   * Create new user
   */
  async createUser(userData) {
    return cmsApi.createUser(userData);
  },

  /**
   * Update user
   */
  async updateUser(id, userData) {
    return cmsApi.updateUser(id, userData);
  },

  /**
   * Delete user
   */
  async deleteUser(id) {
    return cmsApi.deleteUser(id);
  },

  /**
   * Toggle user active status
   */
  async toggleUserStatus(id, isActive) {
    return cmsApi.updateUser(id, {is_active: isActive});
  },

  /**
   * Get current user profile
   */
  async getProfile() {
    return cmsApi.getMe();
  },

  /**
   * Update current user profile
   */
  async updateProfile(profileData) {
    return cmsApi.updateProfile(profileData);
  },

  /**
   * Change password
   */
  async changePassword(currentPassword, newPassword) {
    return cmsApi.changePassword(currentPassword, newPassword);
  },
};

export default userService;
